var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function setAttributesBulk(el, attrs) {
    var keys = Object.keys(attrs);
    keys.forEach(function (key) {
        if (attrs[key] === undefined || attrs[key] === null)
            return;
        el.setAttribute(key, String(attrs[key]));
    });
}
function removeAttributesBulk(el, attrs) {
    var keys = Object.keys(attrs);
    keys.forEach(function (key) {
        if (attrs[key] !== undefined)
            el.removeAttribute(key);
    });
}
export var setTriggerListeners = function (el, handlers) {
    if (!el)
        return;
    var eventNames = Object.keys(handlers);
    eventNames.forEach(function (eventName) {
        var handler = handlers[eventName];
        if (handler)
            el.addEventListener(eventName, handler);
    });
    return function () {
        eventNames.forEach(function (eventName) {
            var handler = handlers[eventName];
            if (handler)
                el.removeEventListener(eventName, handler);
        });
    };
};
export var setTriggerAttributes = function (el, attributes) {
    var originalAttributes = Object.keys(attributes).reduce(function (res, key) {
        var _a;
        return __assign(__assign({}, res), (_a = {}, _a[key] = el.getAttribute(key), _a));
    }, {});
    setAttributesBulk(el, attributes);
    return function () {
        if (!el)
            return;
        removeAttributesBulk(el, attributes);
        setAttributesBulk(el, originalAttributes);
    };
};
